import { Select as UnionSelect } from '@xo-union/tk-component-fields';
import { FieldProps } from 'formik';
import React from 'react';

interface Option {
  option: {
    value: string;
  };
}

interface SelectProps extends FieldProps {
  onChange: (option: Option) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
}

const Select: React.FC<SelectProps> = props => {
  const {
    field,
    form: { touched, errors },
    children,
    ...rest
  } = props;

  return (
    <UnionSelect {...field} {...rest} state={touched[field.name] && errors[field.name] ? 'invalid' : 'neutral'}>
      {children}
    </UnionSelect>
  );
};

export default Select;
